import { types } from "mobx-state-tree"

export const OfflinePatient = types
    .model({
        patientId: types.maybeNull(types.optional(types.number, 0)),
        name: types.maybeNull(types.optional(types.string,"")),
        surname: types.maybeNull(types.optional(types.string, "")),
        tckno: types.maybeNull(types.optional(types.number, 0)),
        mobilePhone: types.maybeNull(types.optional(types.number, 0)),
        gender: types.maybeNull(types.optional(types.number, 0)),
        bloodGroup: types.maybeNull(types.optional(types.number, 0)),
        weight: types.maybeNull(types.optional(types.number, 0)),
        height: types.maybeNull(types.optional(types.number, 0)),
        birthDate: types.maybeNull(types.optional(types.Date, new Date())),
        email: types.maybeNull(types.optional(types.string, ""))
    }).actions(self => ({

    }))